var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[_c('vue-toastr',{ref:"toastr"}),_vm._v(" "),_c('div',{class:{blur: _vm.loading}},[_c('b-row',[_c('b-col',[_c('b-card',{attrs:{"title":"Мои счета"}},[_c('b-table',{attrs:{"items":_vm.accounts,"fields":_vm.accountsFields}})],1)],1)],1)],1),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"loading-container"},[_c('data-loading')],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04dccd2e","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Finance/Accounts.vue
// module id = 416
// module chunks = 1